import * as React from 'react';

interface IItemProps {
  text: string;
  active?: boolean;
  onClick: () => void;
}

const Item = ({ text, active, onClick }: IItemProps) => (
  <li className="inline-block">
    <button
      onClick={onClick}
      className={`p-2 hover:text-blue focus:outline-none ${
        active ? 'text-blue pointer-events-none' : ''
      }`}
    >
      {text}
    </button>
  </li>
);
const EllipsisItem = () => <li className="inline-block p-2">&hellip;</li>;

function getVisibleItems(current: number, count: number) {
  if (count <= 5) {
    return Array.from({ length: count }).map((_, index) => index + 1);
  }
  switch (current) {
    case 1:
    case 2:
      return [1, 2, 3, 'break', count];
    case count - 1:
    case count:
      return [1, 'break', count - 2, count - 1, count];
    default:
      const out: Array<number | string> = [
        1,
        current - 1,
        current,
        current + 1,
        count,
      ];
      if (current > 3) {
        out.splice(1, 0, 'break');
      }
      if (current < count - 2) {
        out.splice(out.length - 1, 0, 'break');
      }
      return out;
  }
}

interface IPaginationProps {
  current: number;
  count: number;
  onChange: (page: number) => void;
  className?: string;
}

export const Pagination: React.FC<IPaginationProps> = ({
  current,
  count,
  onChange,
  className = '',
}) => (
  <ul className={`text-center list-reset ${className}`}>
    <Item text="<" onClick={onChange.bind(null, Math.max(current - 1, 1))} />
    {getVisibleItems(current, count).map((page, index) =>
      page === 'break' ? (
        <EllipsisItem key={index} />
      ) : (
        <Item
          key={index}
          text={String(page)}
          active={current === page}
          onClick={onChange.bind(null, page)}
        />
      )
    )}
    <Item
      text=">"
      onClick={onChange.bind(null, Math.min(current + 1, count))}
    />
  </ul>
);



// WEBPACK FOOTER //
// ./src/components/Pagination.tsx